// Metadados de UI da transcrição: plataforma da reunião e rótulos longos de
// status usados no cabeçalho do modal de detalhe.
//
// Os rótulos aqui são a versão "frase" ("Transcrição finalizada"), pensados para
// a linha corrida do cabeçalho. Os rótulos curtos ("Finalizado", "IA Concluído")
// continuam no TranscriptStatusBadge, que serve a tabela e o histórico.

// Nem toda transcrição vem de reunião de vídeo capturada pela extensão:
// 'mobile_recording' é o áudio gravado no app do profissional e 'phone' é a
// ligação telefônica (valor liberado no CHECK de aawz_transcripts pela migration
// v550). Sem entrada aqui, o cabeçalho exibiria a chave crua.
export const PLATFORM_META = {
  google_meet: { label: 'Google Meet' },
  teams: { label: 'Microsoft Teams' },
  zoom: { label: 'Zoom' },
  mobile_recording: { label: 'Gravação no app' },
  phone: { label: 'Ligação' },
}

// O backend manda 'google-meet' (hífen) ou 'google_meet' (underscore) — a chave
// é normalizada antes de olhar o mapa. Plataforma desconhecida mantém o valor
// cru como rótulo, para não esconder informação do usuário.
export const platformMeta = (raw) => {
  const key = String(raw || '')
    .replaceAll('-', '_')
    .toLowerCase()
  // hasOwnProperty evita cair em membros herdados de Object.prototype quando
  // platform vier algo tipo 'constructor'/'toString'.
  const hasMeta = Object.prototype.hasOwnProperty.call(PLATFORM_META, key)
  if (hasMeta) return PLATFORM_META[key]
  return { label: raw || '' }
}

// Sem cor: na linha de metadados o status é leitura corrida, no mesmo cinza dos
// demais itens. Os badges coloridos (tabela, histórico) seguem no
// TranscriptStatusBadge, com os rótulos curtos.
export const TRANSCRIPT_STATUS_META = {
  ended: { label: 'Transcrição finalizada' },
  in_progress: { label: 'Transcrição em andamento' },
  scheduled: { label: 'Transcrição agendada' },
  failed: { label: 'Transcrição com erro' },
}

export const AI_STATUS_META = {
  completed: { label: 'Resumo concluído' },
  processing: { label: 'Resumo processando' },
  queued: { label: 'Resumo na fila' },
  pending: { label: 'Resumo aguardando' },
  failed: { label: 'Resumo com erro' },
  skipped: { label: 'Resumo ignorado' },
}

// Status desconhecido devolve null para o cabeçalho simplesmente omitir o item.
export const transcriptStatusMeta = (status) => {
  return TRANSCRIPT_STATUS_META[status] || null
}

export const aiStatusMeta = (aiStatus) => {
  return AI_STATUS_META[aiStatus] || null
}
